
import { Component, OnInit, QueryList, ViewChildren, Input, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { InformableDialogComponent, InformableEditInfo } from '../../components/informable/informable.dialog.component';
import { InformableType, InformableSection, Informable, InformableSectionItem } from 'globals/store/informables.data';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { Wrapper } from '../wrapper.component';
import { InformationComponent } from './../information/information.component';
import { CoreEntityType } from 'globals/store/share.data';
import { entityTypesReselector } from '../../store/reselectors/entity.reselector';
import { Dictionary } from '@ngrx/entity';

@Component({
    selector: 'informable',
    templateUrl: './informable.html',
    standalone: true,
    styleUrls: ['./informable.scss'],
    imports: [JoiInputComponent, InformationComponent],
})
export class InformableComponent extends Wrapper<InformableComponent> implements OnInit {

  information: InformableSection[]
  informableId:string

  @Input() informableType: InformableType = 'event';
  @Input() informableKey: string;
  @Input() noItemsMessage = 'No items'
  @Input() singleSectionOnly: boolean
  @Input() useAssetIds: boolean
  @Input() assetEntityHolderName: string
  @Input() readonly
  @Input() mobileCollapse = false
  @Input() allCollapse = false
  @ViewChildren('sectionTitle') sectionTitles: QueryList<JoiInputComponent>
  @ViewChild('informationComponent') informationComponent: InformationComponent

  @Input() entityType: CoreEntityType
  entityTypesMap: Dictionary<Ranking> = {}
  event: JoiEvent

  collapseAll() {
    this.informationComponent.collapseAll()
  }

  expandAll() {
    this.informationComponent.expandAll()
  }

  loadInformable(informable: Informable) {
    console.log({ informable, informableKey: this.informableKey, informableType: this.informableType })
    if (!informable) return;
    this.informableId = informable.id
    this.information = jsonCopyObject(informable.info)
  }

  ngOnInit() { 
    this.subProp(this.store.select('events','event'), 'event')
    const informableObs = this.informableKey ? this.store.select('informables', this.informableType as 'exhibitor' | 'performer' | 'resource' | 'attendee', this.informableKey) : this.store.select('informables', this.informableType as 'event' | 'performers' | 'exhibitors' | 'resources' | 'attendees')
    this.subCallback(informableObs, informable => this.loadInformable(informable))
    if (this.entityType) {
      this.selectCallback(entityTypesReselector, this.entityType, (data: {typesMap: Dictionary<Ranking>}) => {
        if (!data) return
        this.entityTypesMap = data.typesMap as Dictionary<Ranking>
      })
    }

  }

  // drag and drop //
  dropSection(event: CdkDragDrop<InformableSection[]>) {
    moveItemInArray(this.information, event.previousIndex, event.currentIndex);
    this.saveInfo()
  }

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    this.saveInfo();
  }

  // data manipulation //
  addSection() {
    this.information.push({id: createId(), title: '', items: []});
    console.log({ information: jsonCopyObject(this.information) })
    this.saveInfo().then(()=>{
      setTimeout(() => {
        try{
          this.sectionTitles.last.input.nativeElement.focus();
        }catch(e){
          console.error(e)
        }
      }, 0);
    });
  }

  addItem(info: InformableSection) {
    this.openEditor({ sectionId: info.id, information:this.information, informableId:this.informableId, informableType:this.informableType, informableKey:this.informableKey }) 
  }



  openItem({item, info}) {
    this.openEditor({ item, sectionId: info.id, information:this.information, informableId:this.informableId, informableType:this.informableType, informableKey:this.informableKey })
  }

  openEditor(data:InformableEditInfo) {
    data.useAssetIds = this.useAssetIds
    console.log(data)
    data.assetEntityHolderName = this.assetEntityHolderName
    this.dialog.open(InformableDialogComponent, {
      width: '480px',
      disableClose: true,
      data
    })
  }

  deleteSection(info) {
    // dialog + confirmation is inside of information component
    const idx = this.information.findIndex(sec => sec.id === info.id);
    if (idx > -1) {
        this.information.splice(idx, 1);
        this.saveInfo();
    }
  }

  saveSection(section: InformableSection) {
    const index = this.information.findIndex(s => s.id === section.id)
    this.information[index] = section
    console.log({ section })
    this.saveInfo()
  }

  duplicateSection(section: InformableSection) {
    const newSection = jsonCopyObject(section)
    newSection.items = newSection.items.map(i => ({...i, id: createId() }))
    newSection.id = createId()
    newSection.entityTypeIds = []
    this.information.push(newSection)
    this.saveInfo()
  }

  saveInfo(){
    return this.informablesService.saveInformation(this.informableId, this.information, this.informableType)
  }

}